/*
 ** Author: Nuno Alex
 ** Date: 06/2025
 ** Test: GLX-050 | Cart Relayout
 ** Variation: Variation-2
 */

(() => {
	const debugMode = 1,
		testId = "GLX-050",
		logInfo = testId + " -->",
		variation = 2;

	try {
		// Avoid code to run multiple times
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Tampermonkey has a specific window scope. This will make sure you access the correct website's "window" object.
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			// Wait for an element(s) to be fully loaded in the DOM
			const waitForElement = (cssSelector, callback, multi = false, maxCalls = 300) => {
				try {
					let elementsCached;

					const interval = setInterval(() => {
						try {
							if (multi) {
								elementsCached = document.querySelectorAll(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached.length) {
									clearInterval(interval);
									callback(elementsCached);
								}
							} else {
								elementsCached = document.querySelector(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached) {
									clearInterval(interval);
									callback(elementsCached);
								}
							}

							// After trying to find the element for 6 seconds, it stops
							if (typeof maxCalls === "number" && --maxCalls < 0) {
								clearInterval(interval);
							}
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					}, 20);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			const cartSvg = `
				<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M4.00014 13H17.1359C18.1487 13 18.6551 13 19.0582 12.8112C19.4134 12.6448 19.7118 12.3777 19.9163 12.0432C20.1485 11.6633 20.2044 11.16 20.3163 10.1534L20.9013 4.88835C20.9355 4.58088 20.9525 4.42715 20.9031 4.30816C20.8597 4.20366 20.7821 4.11697 20.683 4.06228C20.5702 4 20.4155 4 20.1062 4H3.50014M1 1H2.24844C2.51306 1 2.64537 1 2.74889 1.05032C2.84002 1.09463 2.91554 1.16557 2.96544 1.25376C3.02212 1.35394 3.03037 1.48599 3.04688 1.7501L3.95312 16.2499C3.96963 16.514 3.97788 16.6461 4.03456 16.7462C4.08446 16.8344 4.15998 16.9054 4.25111 16.9497C4.35463 17 4.48694 17 4.75156 17H18M6.5 20.5H6.51M15.5 20.5H15.51M7 20.5C7 20.7761 6.77614 21 6.5 21C6.22386 21 6 20.7761 6 20.5C6 20.2239 6.22386 20 6.5 20C6.77614 20 7 20.2239 7 20.5ZM16 20.5C16 20.7761 15.7761 21 15.5 21C15.2239 21 15 20.7761 15 20.5C15 20.2239 15.2239 20 15.5 20C15.7761 20 16 20.2239 16 20.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			`;

			// Add classes to chat iframes
			const modifyCartDrawer = () => {
				try {
					const cartDrawer = document.querySelector("#cart-drawer");

					if (cartDrawer) {
						const heading = cartDrawer.querySelector("p.h4");
						const urgencyMessage = cartDrawer.querySelector(".GLX-014-checkout-urgency");

						if (heading && urgencyMessage && heading.nextElementSibling !== urgencyMessage) {
							heading.insertAdjacentElement("afterend", urgencyMessage);
						}

						const freeShippingBar = cartDrawer.querySelector("free-shipping-bar");
						if (freeShippingBar && !freeShippingBar.querySelector(`.${testId}-continue-shopping`)) {
							freeShippingBar.insertAdjacentHTML(
								"beforeend",
								`
									<div class="${testId}-continue-shopping">
										<button>
											<span>Continue Shopping</span>
											<svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M1 5.5H14M14 5.5L9.125 1M14 5.5L9.125 10" stroke="black" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
										</button>
									</div>
								`
							);

							const continueShoppingButton = freeShippingBar.querySelector(`.${testId}-continue-shopping button`);

							continueShoppingButton.addEventListener("click", () => {
								try {
									const closeButton = document.querySelector("dialog-close-button");

									if (closeButton) {
										closeButton.click();
									}
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							});

							if (variation === 2) {
								const viewCartButton = cartDrawer.querySelector(".button-group a.button");

								if (viewCartButton && !viewCartButton.querySelector("svg")) {
									viewCartButton.innerHTML = cartSvg;
								}
							}
						}
					}
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			waitForElement("body", (bodyElement) => {
				try {
					new MutationObserver(modifyCartDrawer).observe(bodyElement, {
						childList: true,
						subtree: true
					});

					modifyCartDrawer();
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			});
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();